module.exports = __webpack_public_path__ + "img/game6.2f923d13.png";